import { render, staticRenderFns } from "./newautocalibrationtag.vue?vue&type=template&id=2821c274&scoped=true"
import script from "./newautocalibrationtag.vue?vue&type=script&lang=js"
export * from "./newautocalibrationtag.vue?vue&type=script&lang=js"
import style0 from "./newautocalibrationtag.vue?vue&type=style&index=0&id=2821c274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821c274",
  null
  
)

export default component.exports